import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Col } from 'react-flexbox-grid'

export class TextareaComponent extends Component {
  constructor(props){
    super(props)
  }
  
  render(){
    return (
      <Col xs={12} md={8}>
        <textarea
          name={`textarea_${this.props.field}`}
          onChange={(e) => this.props.onChange(this.props.field.id, this.props.field.category, this.props.field.name, e.target.value)}
          defaultValue={this.props.answer} />
      </Col>
    )
  }
}

TextareaComponent.propTypes = {
  field: PropTypes.object.isRequired,
  answer: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  ckeditorPath: PropTypes.string,
}

export default TextareaComponent
